module.exports = __webpack_public_path__ + "static/media/hover.ff8e134b.svg";